function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import CommentForm from './comment-form';
import CommentList from './comment-list';
import Button from "../../components/button";
import Icon from '../../components/icon';
import { useTineUserFeedback } from './comment-service';
var parseLinks = function (comment) {
  var urlRE = /https?:\/\/[^\s]*/gi;
  return comment.replace(urlRE, function (match) {
    return "<a href=\"".concat(match, "\" target=\"_BLANK\" rel=\"noopener noreferrer\">").concat(match, "</a>");
  });
};
var relativeTime = function (timeCreated) {
  return moment(timeCreated, 'x').fromNow();
};
export var CommentItem = function (_ref) {
  var comment = _ref.comment,
    parentCommentId = _ref.parentCommentId,
    updateCommentform = _ref.updateCommentform,
    rest = _objectWithoutProperties(_ref, ["comment", "parentCommentId", "updateCommentform"]);
  var TineUserFeedback = useTineUserFeedback();
  var _useState = useState(comment.upvotes || 0),
    _useState2 = _slicedToArray(_useState, 2),
    upvotes = _useState2[0],
    setUpvote = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    liked = _useState4[0],
    setLiked = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showCommentForm = _useState6[0],
    setShowCommentForm = _useState6[1];
  var upvoteComment = function () {
    TineUserFeedback.upvoteComment(comment.id).then(function () {
      setLiked(true);
      setUpvote(upvotes + 1);
      var voteData = {
        commentId: comment.id,
        voteTimeStamp: Math.round(new Date().getTime())
      };
      localStorage.setItem("VOTED_ON_COMMENT-".concat(comment.id), JSON.stringify(voteData));
    });
  };
  var decodeHtmlEntities = function (html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value.trim();
  };
  useEffect(function () {
    if (JSON.parse(localStorage.getItem("VOTED_ON_COMMENT-".concat(comment.id))) !== null) {
      setLiked(true);
    }
  }, [liked]);
  return /*#__PURE__*/React.createElement("li", {
    className: "p-comment-item",
    itemScope: true,
    itemType: "http://schema.org/Comment"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-comment-item__signature"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-comment-item__signature-name"
  }, comment.admin ? /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    icon: "chef_hat"
  }) : /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    icon: "comment"
  }), /*#__PURE__*/React.createElement("p", {
    itemProp: "author"
  }, decodeHtmlEntities(comment.firstname), " ", comment.lastname ? decodeHtmlEntities(comment.lastname) : null)), /*#__PURE__*/React.createElement("p", {
    itemProp: "datePublished"
  }, relativeTime(comment.created))), /*#__PURE__*/React.createElement("div", {
    className: "p-comment-item__comment",
    itemProp: "comment",
    dangerouslySetInnerHTML: {
      __html: comment.admin ? parseLinks(comment.comment) : comment.comment
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "p-comment-item__options"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "p-comment-item__options-comment",
    onClick: function () {
      return setShowCommentForm(true);
    }
  }, "Kommenter"), /*#__PURE__*/React.createElement(Button, {
    className: "p-comment-item__options-like",
    "aria-label": "Lik kommentaren",
    itemScope: true,
    itemType: "http://schema.org/LikeAction",
    onClick: function () {
      return upvoteComment();
    },
    disabled: liked
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    icon: "thumb_up"
  })), "(", upvotes, ")", showCommentForm && /*#__PURE__*/React.createElement(CommentForm, {
    parentCommentId: comment.id,
    toggleCommentForm: function () {
      return setShowCommentForm(false);
    },
    updateCommentform: updateCommentform
  })), /*#__PURE__*/React.createElement(CommentList, {
    parentCommentId: comment.id,
    comments: comment.replies
  }));
};
CommentItem.propTypes = {
  comment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    firstname: PropTypes.string.isRequired,
    upvotes: PropTypes.number,
    downvotes: PropTypes.number,
    admin: PropTypes.bool,
    lastname: PropTypes.string,
    created: PropTypes.number,
    replies: PropTypes.array
  })
};
export default CommentItem;